import { ReactElement } from "react";
import { useHistory } from "react-router-dom";
import { TooltipSetup } from "../../../../../hooks/UseTooltip";
import { IIndicatorResult } from "../../../../../services/http/indicatorlist/models/IIndicatorResult";
import IndicatorBadge from "../../../IndicatorBadge";
import { useDependency } from "../../../../../contexts/DependencyContext";
import { WidgetService } from "../../../../../services/widgets/WidgetService";
import styles from './Issue.module.scss';
import { useTimeMachine } from "../../../../../contexts/TimeMachineContext";

interface IIssueProps
{
    component: IIndicatorResult;
    firstIssue: boolean;
    widgetId: number;
    setupTooltip: (x: TooltipSetup | null) => void;
}

const Issue = (props: IIssueProps): ReactElement =>
{
    const { component } = props;
    const history = useHistory();
    const widgetService = useDependency(WidgetService);
    const timeMachine = useTimeMachine();

    function navigate(): void
    {
        if (timeMachine) return;
        history.push(`/dashboard/${component.componentId}/${widgetService.fullscreenWidgets.indicatorList}/${props.widgetId}`);
    };

    return (
        <div className={timeMachine ? styles.issueTime : styles.issue } >
            <IndicatorBadge statusId={component.statusId} statusName={component.statusName} />

            <div className={styles.currentValue} onClick={navigate}>
                {component.name && <span className={styles.name}>{component.name}</span>}
                {component.description && <span className={styles.description}>{component.description}</span>}
            </div>
        </div>
    );
}

export default Issue;